








































































































































import BaseComponent from '@/core/base.component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import FounderConsultService from '@/services/founder-consult.service';
import {
  FounderConsultDto,
  FounderConsultReplyDto,
  CompanyFounderConsultFetchDto,
} from '@/dto/founder-consult';
import CardWithTitle from '@/modules/_common/components/CardWithTitle.vue';
import TableWithTitle from '@/modules/_common/components/TableWithTitle.vue';
import { animationFrameScheduler } from 'rxjs';
import codeManagementService from '@/services/init/code-management.service';
import { CodeManagementDto } from '@/services/init/dto';
import { B2B_FOUNDER_CONSULT } from '@/services/shared';
import SpaceInfoCard from '@/modules/_common/components/cards/SpaceInfoCard.vue';
import SpaceTypeDetailDialog from '@/modules/company/components/district/components/SpaceTypeDetailDialog.vue';
@Component({
  name: 'FounderConsultDetail',
  components: {
    CardWithTitle,
    TableWithTitle,
    SpaceInfoCard,
    SpaceTypeDetailDialog,
  },
})
export default class FounderConsultDetail extends BaseComponent {
  private founderConsultDto = new FounderConsultDto();
  private founderConsultReplyDto = new FounderConsultReplyDto();
  private loading = false;
  private companyFounderConsultList: CodeManagementDto[] = [];
  private companyFounderFetchDto = new CompanyFounderConsultFetchDto();
  private isContractComplete = true;
  private spaceTypeDetailDialog = false;
  private spaceTypeNo: number | string | string[] = null;
  private nanudaUserTableHeader: any[] = [
    {
      text: '이름',
      value: 'name',
      align: 'center',
      sortable: false,
    },
    {
      text: '전화번호',
      value: 'phone',
      align: 'center',
      sortable: false,
    },
    {
      text: '성별',
      value: 'genderInfo.value',
      align: 'center',
      sortable: false,
    },
  ];
  private spaceTableHeader: any[] = [
    {
      text: '지점',
      value: 'deliverySpace.companyDistrict.nameKr',
      align: 'center',
      sortable: false,
    },
    {
      text: '타입',
      value: 'deliverySpace.typeName',
      align: 'center',
      sortable: false,
    },
    // {
    //   text: '주소',
    //   value: 'companyDistrict.address',
    //   align: 'center',
    //   sortable: false,
    // },
  ];
  @Watch('founderConsultDto', { deep: true })
  founderConsultDtoChanged() {
    this.companyFounderFetchDto.companyDecisionStatus = this.founderConsultDto.companyDecisionStatus;
  }
  getDetail() {
    this.loading = true;
    FounderConsultService.findOne(this.$route.params.id).subscribe(res => {
      if (!res) {
        this.$router.push('/dashboard');
      } else {
        this.founderConsultDto = res.data;
        res.data.companyDecisionStatus === 'B2B_F_CONTRACT_COMPLETE'
          ? (this.isContractComplete = true)
          : (this.isContractComplete = false);
        this.loading = false;
      }
    });
  }

  ifConsultComplete(status?: B2B_FOUNDER_CONSULT) {
    if (status === B2B_FOUNDER_CONSULT.B2B_F_CONTRACT_COMPLETE) {
      this.patchDetail();
    }
  }
  getReply() {
    FounderConsultService.findAllReply(this.$route.params.id).subscribe(res => {
      if (res) {
        this.founderConsultReplyDto = res.data;
      }
    });
  }
  getCompanyFounderConsultList() {
    codeManagementService
      .findCompanyFounderConsultStatusList()
      .subscribe(res => {
        this.companyFounderConsultList = res.data;
      });
  }
  patchDetail() {
    if (this.companyFounderFetchDto === this.founderConsultDto) {
      return;
    }
    FounderConsultService.patchOne(
      this.$route.params.id,
      this.companyFounderFetchDto,
    ).subscribe(res => {
      if (res) {
        this.$toasted.global.custom_success({ message: '수정 성공!' });
      }
    });
  }
  created() {
    this.getDetail();
    this.getReply();
    this.getCompanyFounderConsultList();
  }
}
